import { Box, Flex, Icon } from "@chakra-ui/react";
import { RiskFactor, riskFactorColors } from "@keita/lanepatrol-sdk";
import {
  ScoreFilter,
  ScoreFilterType,
} from "../../../../../map/models/MapFilters";
import { CheckIcon } from "../../../../../shared/views/icons";

interface Props {
  filter?: ScoreFilter;
  setFilter: (filter: ScoreFilter) => void;
}
export const RiskFactorSelector: React.FC<Props> = ({ filter, setFilter }) => {
  const toggleRiskFactor = (riskFactor: RiskFactor) => {
    const riskFactors =
      filter?.type === ScoreFilterType.RiskFactors ? filter.riskFactors : [];

    setFilter({
      riskFactors: riskFactors.includes(riskFactor)
        ? riskFactors.filter((item) => item !== riskFactor)
        : [...riskFactors, riskFactor],
      type: ScoreFilterType.RiskFactors,
    });
  };

  return (
    <Box mb={4}>
      <Flex
        my={2}
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
        borderRadius={6}
      >
        {Object.values(RiskFactor).map((rf, i) => (
          <Box
            onClick={() => toggleRiskFactor(rf)}
            h={6}
            flexGrow={1}
            flexShrink={0}
            key={i}
            bg={riskFactorColors[rf]}
            opacity={
              filter?.type === ScoreFilterType.RiskFactors &&
              filter.riskFactors.includes(rf)
                ? 1
                : 0.5
            }
            textAlign="center"
            _hover={{
              opacity: 0.8,
              cursor: "pointer",
            }}
          >
            <Icon
              as={CheckIcon}
              color="white"
              opacity={
                filter?.type === ScoreFilterType.RiskFactors &&
                filter.riskFactors.includes(rf)
                  ? 1
                  : 0
              }
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};
